<template>
    <spinner v-if="isLoading"></spinner>
    <transition name="fade">
        <div>
            <BreadCrumbs
                :breadCrumbs="breadCrumbs"
                :title="title"
                :back_title="back_title"
                :link="link"
            />
            <div class="page d-flex flex-column justify-content-center mt-0">

                    <div class="item_title">
                        {{ checkName }}
                    </div>
                    <div class="block_item">
                        <div class="mb-2" v-for="checklist in this.checklists" :key="checklist.id">
                            <div class="cl_item little" @click="next(checklist.id)" :class="goClass(checklist.status)">
                                {{ checklist.name }}
                            </div>
                        </div>
                        <button class="btn btn-green mt-4 btn_vw mb-4" :disabled="active" :class="{ active: active }" @click="save">СОХРАНИТЬ</button>
                    </div>

            </div>
        </div>
    </transition>
</template>

<script>
import axios from "axios";
import spinner from '../../../components/Spinner';
import BreadCrumbs from "../../../Page/BreadCrumbs";

export default {
    name: "CarSubcheckList",
    components: {
        spinner, BreadCrumbs
    },
    data(){
        return {
            isLoading: false,
            checklists: [],
            itemName: '',
            active: false,
            breadCrumbs: true,
            title: 'Список вопросов',
            back_title: 'Номер автомобиля',
            link: 'car/' + this.$route.params.check_id,
        }
    },
    created() {
        this.getChecklists();
    },
    methods: {
        save(){
            const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
            axios.post('/api/admin/car/save', {
                car_id: this.$route.params.car_id,
                check_id: this.$route.params.check_id,
                subcheck_id: this.$route.params.subcheck_id,
            }, config)
                .then(response => {
                    if (response.status == 200) {
                        this.$router.push('/tsm')
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        next(id) {
            this.$router.push(`/car/${this.$route.params.check_id}/${this.$route.params.car_id}/${id}`);
        },
        async getChecklists() {
            try {
                this.isLoading = true;
                const config = {'headers': {'Authorization': 'Bearer ' + this.$cookie.getCookie('token')}};
                const response = await axios.get(`/api/admin/car/subcheck/${this.$route.params.check_id}/${this.$route.params.car_id}`, config);
                this.checklists = response.data.data.checklists;
                this.checkName = response.data.data.checkName;
                this.active = response.data.data.status;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        goClass(status_check) {
            return `type_${status_check}`;
        },
    }
}
</script>

<style scoped>

</style>
